import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';

import MaintenanceGate from './MaintenanceGate';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <MaintenanceGate />
  </React.StrictMode>
);